
export class KnowledgeBaseFilterInfo {
    searchTerm: String;
    kbaType: number;
    createdFromDate: string;
    createdToDate: string;
    categoryIds: number[] | null;
    itemTypeIds: number[] | null;
    problemTypeIds: number []| null;
    kbaTabType: string;
}

